var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "topnav hidden-xs",
      class: { agencyisloggedin: _vm.getFlagSharedAgencyLoggedIn === true },
    },
    [
      _c("div", { staticClass: "container" }, [
        _c("ul", { staticClass: "quick-menu pull-left" }, [
          _c(
            "li",
            { staticClass: "ribbon" },
            [
              _c("a", [
                _vm._v(
                  _vm._s(_vm.language[_vm.getCurrentLocale]) +
                    " (" +
                    _vm._s(_vm.getCurrentLocale) +
                    ")"
                ),
              ]),
              _vm._v(" "),
              _c("ul", { staticClass: "menu mini" }, [
                _c("li", { class: { active: _vm.getCurrentLocale === "de" } }, [
                  _c(
                    "a",
                    {
                      attrs: { href: "#", title: "Deutsch" },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          _vm.changeLanguage("de")
                        },
                      },
                    },
                    [_vm._v("Deutsch")]
                  ),
                ]),
                _vm._v(" "),
                _c("li", { class: { active: _vm.getCurrentLocale === "en" } }, [
                  _c(
                    "a",
                    {
                      attrs: { href: "#", title: "English" },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          _vm.changeLanguage("en")
                        },
                      },
                    },
                    [_vm._v("English")]
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("v-dialog"),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _vm.getFlagSharedAgencyLoggedIn === false
          ? _c("ul", { staticClass: "quick-menu pull-right" }, [
              _c("li", [
                _c(
                  "a",
                  {
                    ref: "sundairlogin",
                    staticClass: "soap-popupbox",
                    attrs: { href: "#sundair-login" },
                  },
                  [_vm._v(_vm._s(_vm.agencylogin[_vm.getCurrentLocale]))]
                ),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.getFlagSharedAgencyLoggedIn === true
          ? _c("ul", { staticClass: "quick-menu pull-right" }, [
              _c("li", [
                _c(
                  "a",
                  {
                    attrs: { href: "#" },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        _vm.onClick_AgencyLogout()
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.agencylogout[_vm.getCurrentLocale]))]
                ),
              ]),
            ])
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }